import Enum from "../../../../enums/Enum";
import React from "react";

const InformedConsentFormRadTextEnum = new Enum({
    Informed_Consent_Title: {English: "INFORMED CONSENT", Arabic: "نموذج إقرار بالموافقة"},
    Informed_Consent: {English: "INFORMED CONSENT", Arabic: "إقرار بالموافقة"},
    Informed_Consent_Form: {English: "Informed Consent Form", Arabic: "نموذج إقرار بالموافقة"},
    Date_Of_Admission: {English: "Date of Admission", Arabic: "تاريخ الدخول"},
    MRN: {English: "MRN", Arabic: "رقم الملف الطبي"},
    ID_No: {English: "ID No.", Arabic: "رقم الهوية"},
    Date_Of_Birth: {English: "Date of Birth", Arabic:"تاريخ الميلاد" },

    // Radiology Procedure Consent Section
    Radiology_Procedure_Consent_Title: {
        English: "Radiology Procedure Consent",
        Arabic: "موافقة على إجراء الأشعة"
    },

    Radiology_Procedure_Paragraph_1: {
        English: "I, the undersigned, acknowledge that the radiological diagnostic procedure has been clearly explained to me, including the type of scan (e.g., X-ray, Ultrasound, DEXA) and its medical purpose.",
        Arabic: "أنا الموقع أدناه، أُقرّ بأنه قد تم شرح إجراء التشخيص الإشعاعي لي بوضوح، بما في ذلك نوع الفحص (مثل الأشعة السينية، الموجات فوق الصوتية، (DEXA والغرض الطبي منه."
    },

    Radiology_Procedure_Point_1: {
        English: "It was clarified that some of these examinations involve minimal radiation exposure.",
        Arabic: "تم توضيح أن بعض هذه الفحوصات تتطلب تعرضًا إشعاعيًا ضئيلًا."
    },

    Radiology_Procedure_Point_2: {
        English: "The benefits and any potential risks have been explained in terms I understand.",
        Arabic: "تم شرح الفوائد والمخاطر المحتملة بعبارات أفهمها."
    },

    Radiology_Procedure_Point_3: {
        English: "I confirm that I have had the opportunity to ask questions and that they were answered to my satisfaction.",
        Arabic: "أُؤكد أنه أتيحت لي الفرصة لطرح الأسئلة، وقد تمت الإجابة عليها بما يُرضيني."
    },

    Radiology_Procedure_Point_4: {
        English: "I understand that participation in this scan is voluntary, and I have the right to refuse or withdraw my consent at any time.",
        Arabic: "أُدرك أن المشاركة في هذا الفحص طوعية، ولي الحق في رفض أو سحب موافقتي في أي وقت."
    },

    Radiology_Procedure_Point_5: {
        English: "I confirm I have accurately disclosed relevant medical history, including pregnancy status and implanted medical devices.",
        Arabic: "أُقرّ بأنني قد أفصحت بدقة عن تاريخي الطبي ذي الصلة، بما في ذلك حالة الحمل والأجهزة الطبية المزروعة."
    },

    // Radiation Risk & Pregnancy Declaration  
    Radiation_Risk_Pregnancy_Title: {
        English: "Radiation Risk & Pregnancy Declaration Form",
        Arabic: "نموذج إعلان مخاطر الإشعاع والحمل"
    },

    Acknowledgement_Radiation_Pregnancy_Title: {
        English: "Acknowledgement of Radiation Exposure Risks & Pregnancy Status",
        Arabic: "إقرار بمخاطر التعرض للإشعاع وحالة الحمل"
    },

    Radiation_Risk_Paragraph_1: {
        English: "The radiation used in the X‑ray may be harmful to an unborn child or developing fetus, especially in the first trimester. But the risk to you and your unborn child are very small and the risk of not having the x‑ray could be much greater than the risk of the radiation. As a routine part of our practice, all women of child‑bearing age are asked about their pregnancy status and last menstrual period. If you are pregnant, or think that you might be, it is best to avoid radiation exposure, unless your doctor decides that your test is more beneficial.",
        Arabic: "قد يكون الإشعاع المستخدم في الأشعة السينية ضارًا بالجنين أو الجنين النامي، خاصةً في الأشهر الثلاثة الأولى من الحمل. لكن الخطر عليكِ وعلى جنينكِ ضئيل جدًا، وقد يكون خطر عدم الخضوع للأشعة السينية أكبر بكثير من خطر الإشعاع. كجزء روتيني من ممارستنا، تُسأل جميع النساء في سن الإنجاب عن حالة حملهن وآخر دورة شهرية لهن. إذا كنتِ حاملًا، أو تعتقدين أنكِ حامل، فمن الأفضل تجنب التعرض للإشعاع، إلا إذا قرر طبيبكِ أن فحصكِ أكثر فائدة."
    },

    Radiation_Understanding_Point_1: {
        English: "I understand that certain radiological procedures, including but not limited to X-rays, involve exposure to ionizing radiation.",
        Arabic: "أُدرك أن بعض الإجراءات الإشعاعية، بما في ذلك على سبيل المثال لا الحصر الأشعة السينية، تنطوي على التعرض للإشعاع المؤين."
    },

    Radiation_Understanding_Point_2: {
        English: "The risks of radiation exposure have been explained to me, especially in the context of pregnancy.",
        Arabic: "لقد تم شرح مخاطر التعرض للإشعاع لي، خاصةً في سياق الحمل."
    },

    Radiation_Understanding_Point_3: {
        English: "I understand that exposure during pregnancy may have harmful effects on fetal development.",
        Arabic: "أُدرك أن التعرض أثناء الحمل قد يكون له آثار ضارة على نمو الجنين."
    },

    Pregnancy_Declaration_Options: {
        English: "Please select one:",
        Arabic: "الرجاء اختيار واحد:"
    },

    Pregnancy_Option_1: {
        English: "I confirm that I am NOT pregnant",
        Arabic: " أؤكد أنني لستُ حاملًا"
    },

    Pregnancy_Option_2: {
        English: "I confirm that I AM pregnant",
        Arabic: "أؤكد أنني حامل"
    },

    Pregnancy_Option_3: {
        English: "I am UNSURE — and understand a urine pregnancy test may be performed",
        Arabic: " لستُ متأكدة - وأتفهم أنه قد يُجرى اختبار حمل عن طريق البول"
    },

    Pregnancy_Option_4: {
        English: "N/A — This question does not apply to me",
        Arabic: "غير منطبق - هذا السؤال لا ينطبق علي"
    },

    Voluntary_Consent_Paragraph: {
        English: "I voluntarily consent to undergo the imaging procedure after understanding the risks and benefits. I have been fully informed of the risks involved in radiation exposure during pregnancy and voluntarily allow DISC-Diagnostics to do the requested Imaging (X‑ray) procedure(s) assuming the responsibility for any consequence from the procedure(s) I may have.",
        Arabic: "أوافق طواعيةً على الخضوع لإجراء التصوير بعد فهمي للمخاطر والفوائد. لقد أُطلعتُ طواعيةً على مخاطر التعرض للإشعاع أثناء الحمل، وأسمحُ طواعيةً ل DISC-Diagnostics بإجراء إجراءات التصوير (الأشعة السينية) المطلوبة، متحمّلةً مسؤولية أي عواقب قد تترتب على الإجراء (الإجراءات) التي قد أتعرض لها."
    },

    // Type of Modality Section
    Type_Of_Modality_Title: {
        English: "Type of Modality",
        Arabic: "نوع وسيلة التشخيص"
    },

    Modality_Option_X_Ray: {
        English: "X-Ray",
        Arabic: "الأشعة السينية"
    },

    Modality_Option_Ultrasound: {
        English: "Ultrasound",
        Arabic: "الموجات فوق الصوتية"
    },

    Modality_Option_DEXA: {
        English: "DEXA",
        Arabic: "فحص كثافة العظام"
    },

    // Remote Radiology Reporting Consent
    Remote_Radiology_Title: {
        English: "Consent for Remote Radiology Reporting and Image Sharing",
        Arabic: "الموافقة على إعداد تقارير الأشعة عن بُعد ومشاركة الصور"
    },

    Remote_Radiology_Paragraph_1: {
        English: "I understand that my radiology images may be transmitted electronically to a DHA-licensed radiologist who is located off-site for interpretation.",
        Arabic: "أُقرّ بأنه يجوز إرسال صور الأشعة الخاصة بي إلكترونيًا إلى أخصائي أشعة مُرخص من هيئة الصحة بدبي، متواجد خارج الموقع، لتفسيرها."
    },

    Remote_Radiology_Paragraph_2: {
        English: "I consent to this practice and understand that it ensures timely reporting and quality diagnostics.",
        Arabic: "أُوافق على هذه الممارسة، وأُقرّ بأنها تضمن الإبلاغ في الوقت المناسب وتشخيصًا عالي الجودة."
    },

    Remote_Radiology_Paragraph_3: {
        English: "All data transfers will be performed securely, and my information will remain confidential in accordance with UAE data protection laws.",
        Arabic: "ستُجرى جميع عمليات نقل البيانات بأمان، وستبقى معلوماتي سرية وفقًا لقوانين حماية البيانات في دولة الإمارات العربية المتحدة."
    },

    Remote_Radiology_Paragraph_4: {
        English: "I also give permission for my radiology report to be shared with my referring physician and/or my insurance provider when needed.",
        Arabic: "أُوافق أيضًا على مشاركة تقرير الأشعة الخاص بي مع طبيبي المُحيل و/أو شركة التأمين الخاصة بي عند الحاجة."
    },

    // Data Collection and Privacy (DISC-Diagnostics specific)
    Data_Collection_Privacy_Title: {
        English: "Data Collection and Privacy",
        Arabic: "جمع البيانات والخصوصية"
    },

    Data_Collection_Paragraph_1: {
        English: "During your procedure at DISC-Diagnostics, we will gather information about your personal health information. This is limited to: demographic information, medical history, test and lab results, and insurance information. DISC-Diagnostics is committed to protecting your personal information in accordance with our Privacy Policy and the laws of the United Arab Emirates.",
        Arabic: "أثناء علاجك في  DISC-Diagnosticسنجمع بيانات حول معلوماتك الصحية الشخصية. يقتصر هذا على: المعلومات الديموغرافية والتاريخ الطبي ونتائج الاختبارات والمختبرات والصحة العقلية ومعلومات التأمين والبيانات التي يجمعها المتخصصون في الرعاية الصحية. يلتزم (مركز ديسك للعلاج الطبيعي- دبي) بحماية معلوماتك الشخصية وفقًا لسياسة الخصوصية الخاصة بنا وقوانين دولة الكويت."
    },

    Data_Collection_Paragraph_2: {
        English: "We collect, use and disclose personal health information for the primary purpose of safely and effectively providing you with a seamless experience of our services. This disclosure of personal health information shall be disclosed to the following parties and reasons: treatment (defined as: provision, coordination, or management of health care and related services by one or more health care providers, consultation or patient referral between health care providers relating to a patient), healthcare operations, payment and billing, help with public health and safety matters and comply with the law.",
        Arabic: "نحن نجمع المعلومات الصحية الشخصية ونستخدمها ونفصح عنها لغرض أساسي هو تزويدك بتجربة سلسة لخدماتنا بأمان وفعالية. يجب الإفصاح عن المعلومات الصحية الشخصية للأطراف والأسباب التالية: العلاج (يُعرَّف بأنه: توفير أو تنسيق أو إدارة الرعاية الصحية والخدمات ذات الصلة من قبل واحد أو أكثر من مقدمي الرعاية الصحية، أو الاستشارة أو إحالة المريض بين مقدمي الرعاية الصحية فيما يتعلق للمريض)، وعمليات الرعاية الصحية، والدفع والفواتير، والمساعدة في مسائل الصحة والسلامة العامة والامتثال للقانون."
    },

    Data_Protection_Title: {
        English: "We understand the importance of protecting personal information. For this reason, we have taken the following steps:",
        Arabic: "نحن نتفهم أهمية حماية المعلومات الشخصية، ولهذا السبب اتخذنا الخطوات التالية:"
    },

    Data_Protection_Step_1: {
        English: "Paper information is stored in a restricted area at all times",
        Arabic: "يتم تخزين المعلومات الورقية في منطقة محظورة في جميع الأوقات؛"
    },

    Data_Protection_Step_2: {
        English: "Electronic hardware has restricted access at all times",
        Arabic: "تم تقييد الوصول إلى الأجهزة الإلكترونية في جميع الأوقات،"
    },

    Data_Protection_Step_3: {
        English: "Electronic information is transmitted through direct lines using encryption and marked as 'personal and confidential'.",
        Arabic: "يتم إرسال المعلومات الإلكترونية عبر خطوط مباشرة باستخدام التشفير ويتم تمييزها على أنها \"شخصية وسرية\"؛"
    },

    Data_Protection_Step_4: {
        English: "Staff is trained to collect, use, and disclose personal information, as stated above as necessary to fulfill their duties in accordance with our privacy policies.",
        Arabic: "يتم تدريب الموظفين على جمع المعلومات الشخصية واستخدامها والكشف عنها، كما هو مذكور أعلاه حسب الضرورة للوفاء بواجباتهم وفقًا لسياسات الخصوصية الخاصة بنا؛"
    },

    Data_Protection_Step_5: {
        English: "External consultants and agencies with access to personal information (Insurance companies) must enter into privacy agreements with us.",
        Arabic: "يجب أن يبرم المستشارون والوكالات الخارجية الذين لديهم إمكانية الوصول إلى المعلومات الشخصية (شركات التأمين) اتفاقيات خصوصية معنا."
    },

    Data_Disclaimer_1: {
        English: "*We do not share personal information with any agencies not directly related to your treatment care and we do not provide our patient's information to solicitors.",
        Arabic: " *نحن لا نشارك المعلومات الشخصية مع أي وكالات لا تتعلق مباشرة برعايتك العلاجية ولا نقدم معلومات مريضنا إلى المحامين."
    },

    Data_Disclaimer_2: {
        English: "*Marketing – we will obtain your written authorization before using your health information to send marketing materials",
        Arabic: " *التسويق - سنحصل على إذن كتابي منك قبل استخدام معلوماتك الصحية لإرسال مواد تسويقية."
    },

    // Patient Rights
    Patient_Rights_Title: {
        English: "You have the right to:",
        Arabic: "لديك الحق في:"
    },

    Patient_Rights_Item_1: {
        English: "Get a copy of your paper or electronic medical record",
        Arabic: "الحصول على نسخة من سجلك الطبي سواء ورقياً او إلكترونيا؛"
    },

    Patient_Rights_Item_2: {
        English: "Request confidential communications – you can make a written request that we communicate with you about medical matters in a certain way. For example, you may request that we contact you only in writing.",
        Arabic: "طلب اتصالات سرية - يمكنك تقديم طلب كتابي للتواصل معك بشأن الأمور الطبية بطريقة معينة. على سبيل المثال، قد تطلب منا الاتصال بك كتابيًا فقط."
    },

    Patient_Rights_Item_3: {
        English: "Be notified of a breach – we will notify you in the event of a breach of your protected health information.",
        Arabic: "الإحاطة علماً بأي انتهاك او خرق للمعلومات - سوف نخطركم في حالة حدوث خرق لمعلوماتكم الصحية المحمية."
    },

    Patient_Rights_Item_4: {
        English: "Get a copy of this privacy notice",
        Arabic: "الحصول على نسخة من إشعار الخصوصية هذا."
    },

    Patient_Rights_Item_5: {
        English: "Request to correct or amend your health information - you have the right to request in writing that personal health information that we maintain about you be amended or corrected only if the information we have is incorrect and/or does not reflect updated information. We are not obligated to make all requested amendments but will give each careful consideration.",
        Arabic: "طلب تصحيح أو تعديل معلوماتك الصحية - يحق لك أن تطلب كتابيًا تعديل أو تصحيح المعلومات الصحية الشخصية التي نحتفظ بها عنك فقط إذا كانت المعلومات التي لدينا غير صحيحة و/ أو لا تعكس المعلومات المحدثة. لسنا ملزمين بإجراء جميع التعديلات المطلوبة ولكننا سننظر بعناية في كل منها."
    },

    Patient_Rights_Item_6: {
        English: "Revoke your Consent prior to the commencement of your procedure.",
        Arabic: "إلغاء موافقتك قبل بدء الإجراء الخاص بك."
    },

    // Questions and Concerns
    Questions_Concerns_Title: {
        English: "Questions or concerns",
        Arabic: " الاستفسارات والمخاوف"
    },

    Questions_Concerns_Paragraph: {
        English: "You are encouraged to ask questions at any time regarding your procedure. Bring any concerns you have to your Healthcare Provider's attention. If you are not comfortable, you may stop treatment at any time. You have the right to have your concerns heard and resolved when possible.",
        Arabic: "لا تتردد في طرح أي أسئلة قد تخطر في ذهنك في أي وقت بخصوص التقييم والعلاج. أبلغ طبيبك أو معالجك حول أي مخاوف لديك. إذا لم تكن مرتاحاً، يمكنك التوقف عن العلاج في أي وقت. لك الحق في أن يتم الإصغاء إلى استفساراتك وحلها عندما يكون ذلك ممكناً."
    },

    // Complaints
    Complaints_Title: {English: "Complaints", Arabic: "الشكاوى"},

    Complaints_Paragraph: {
        English: "Patients have a right to voice complaints about their care or experience at the clinic and to have those complaints reviewed and, when possible, resolved. An internal complaint form is available at our front reception. If you are not happy with how your concern is resolved, you may file a complaint with The Dubai Health Authority (DHA).",
        Arabic: "للمرضى الحق في تقديم شكاوى بشأن الرعاية التي يتلقونها أو تجربتهم في العيادة، وأن تتم مراجعة هذه الشكاوى وحلها، إن أمكن. يتوفر نموذج شكوى داخلي في مكتب الاستقبال. إذا لم تكن راضيًا عن كيفية حل مشكلتك، يمكنك تقديم شكوى إلى هيئة الصحة بدبي."
    },

    // Final Consent
    Final_Consent_Paragraph_1: {
        English: "Please be involved in and responsible for your care. Inform your Healthcare Provider immediately of any change in your condition.",
        Arabic: "يرجى المشاركة في رعايتك وتحمل مسؤوليتها. أبلغ مقدم الرعاية الصحية فورًا بأي تغيير في حالتك."
    },

    Final_Consent_Paragraph_2: {
        English: "I hereby acknowledge I understand the nature of the procedure to be provided to me. I have considered the benefits and risks of the procedure, as well as the alternatives. I hereby consent to the Imaging service as described to me. I grant DISC-Diagnostics permission to contact me directly via telephone, text message or email to discuss any matter that may arise in the future.",
        Arabic: "أقرّ بفهمي لطبيعة الإجراء الذي سيُقدّم لي. لقد درستُ فوائد ومخاطر الإجراء، بالإضافة إلى البدائل المتاحة. أوافق بموجب هذا على خدمة التصوير كما وُصفت لي. أمنح DISC-Diagnostics الإذن بالتواصل معي مباشرةً عبر الهاتف أو الرسائل النصية أو البريد الإلكتروني لمناقشة أي مسألة قد تطرأ في المستقبل."
    },

    Final_Consent_Paragraph_3: {
        English: "I understand that to provide me with Imaging services, DISC-Diagnostics is required to collect personal information. I understand the collection, use, and disclosure of this personal information, and I have been given the chance to ask questions with respect to clarification.",
        Arabic: "أُدرك أنه لتقديم خدمات التصوير لي، يتعين على DISC-Diagnostics جمع معلومات شخصية. كما أُدرك جمع هذه المعلومات الشخصية واستخدامها والإفصاح عنها، وقد أُتيحت لي الفرصة لطرح أسئلة للتوضيح."
    },

    // Witness Statement
    Witness_Statement_Title: {English: "Witness Statement", Arabic: "إفادة الشاهد"},
    
    Witness_Statement_Text: {
        English: "I have accurately read or witnessed the accurate reading of the consent form to the potential patient, and the individual has had the opportunity to ask questions. I confirm that the individual has given consent freely.",
        Arabic: "لقد قرأتُ بدقة، أو شهدتُ قراءة دقيقة، نموذج الموافقة المُقدّم للمريض المُحتمل، وأُتيحت له فرصة طرح الأسئلة. أُؤكد أن هذا الشخص قد أعطى موافقته بمحض إرادته."
    },

    // Signature Fields
    Date: {English: "Date", Arabic: "التاريخ"},
    Patients_Name: {English: "Patient's name (Please print)", Arabic: "اسم المريض (يرجى كتابة الاسم)"},
    Provider_Name: {English: "Provider's Name", Arabic: "اسم المعالج"},
    Legal_Guardian_Name: {English: "Legal Guardian Name (Please Print)", Arabic: "اسم الوصي (يرجى كتابة الاسم)"},
    Relationship_To_Patient: {English: "Relationship to Patient", Arabic: "صلة العلاقة بالمريض"},
    Signature_of_Patient: {English: "Signature of Patient (or legal guardian)", Arabic: "توقيع المريض (أو الوصي القانوني)"},
    Signature_of_Provider: {English: "Signature of Provider", Arabic: "توقيع المعالج"},
    Name_of_Witness: {English: "Name of Witness (Please print)", Arabic: "اسم الشاهد."},
    Signature_of_Witness: {English: "Signature of Witness", Arabic: "امضاء الشاهد"},
    
    // Form validation and interaction
    Signature_Required: {English: "Signature required", Arabic: "التوقيع مطلوب"},
    Provider_Required: {English: "Provider required", Arabic: "مقدم الخدمة مطلوب"},
    Signature_input_Signature: {English: "Signature", Arabic: "إمضاء"},
    Signature_input_Clear: {English: "Clear", Arabic: "حذف"},
    Wizard_Previous: {English: "Previous", Arabic: "السابق"},
    Wizard_Next: {English: "Next", Arabic: "التالي"},
    Wizard_Save: {English: "Save", Arabic: "حفظ"},

    // Healthcare Provider Gender Acknowledgment
    Healthcare_Provider_Gender_Title: {
        English: "Healthcare Provider Gender Acknowledgment",
        Arabic: "إقرار جنس مقدم الرعاية الصحية"
    },

    Healthcare_Provider_Gender_Statement: {
        English: "I hereby acknowledge I understand and consent to receiving care from a Healthcare Provider who is of a different Gender than myself.",
        Arabic: "أقر بموجب هذا أنني أفهم وأوافق على تلقي الرعاية من مقدم رعاية صحية من جنس مختلف عني."
    },

    Healthcare_Provider_Permission_Statement: {
        English: "I consent voluntarily and grant the Healthcare Provider permission to provide the treatment or procedure and understand that I have the right to withdraw from the procedure or treatment at any time without in any way affecting my medical care.",
        Arabic: "أوافق طوعياً وأمنح مقدم الرعاية الصحية الإذن لتوفير العلاج أو الإجراء وأفهم أن لي الحق في الانسحاب من الإجراء أو العلاج في أي وقت دون التأثير بأي شكل من الأشكال على رعايتي الطبية."
    },

    // Yes/No Options for acknowledgment radio buttons
    Yes: {English: "Yes", Arabic: "نعم"},
    No: {English: "No", Arabic: "لا"}

});

export default InformedConsentFormRadTextEnum;